<template>
  <VueApexCharts
    type="polarArea"
    :options="polarAreaChart.options"
    :series="polarAreaChart.series"
    class="col-sm-12 col-md-6 m-auto"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: {
    settings: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      polarAreaChart: {
        options: {
          dataLabels: {
            dropShadow: {
              enabled: false,
              top: 1,
              left: 1,
              blur: 1,
              opacity: 0.45,
            },
          },
          colors: ["#fb5597", "#f59c1a", "#348fe2", "#00acac", "#8753de"],
          labels: ["Team A", "Team B", "Team C", "Team D", "Team E"],
          title: {
            text: "HeatMap Chart (Single color)",
          },
        },
        series: [44, 55, 13, 43, 22],
      },
    };
  },
  components: {
    VueApexCharts,
  },
};
</script>
